const SearchResult = ({ data }) => {
  let typeUrl;

  switch (data.type) {
    case "Profil":
      typeUrl = data.url;
      break;
    case "Blogg":
      typeUrl = "/blogs";
      break;
    case "Nyhet":
      typeUrl = "/news";
      break;
    default:
      typeUrl = `/${data.type.toLowerCase()}`;
      break;
  }

  return (
    <div className="bg-[#131313] border border-white/10 rounded-2xl min-h-[5rem] my-2.5 p-4 px-5 flex flex-col justify-center shadow-md hover:border-white/20 transition-all duration-300 hover:scale-[1.01]">
      <div className="flex justify-between items-start gap-3 mb-3">
        <a
          href={data.url}
          className="font-extrabold text-sm sm:text-base text-white uppercase tracking-wide overflow-hidden hover:text-[#0047ff] transition-colors"
        >
          {data.title}
        </a>
        <a
          href={typeUrl}
          className="shrink-0 inline-flex items-center px-2.5 py-1 rounded-full bg-[#0047ff]/10 text-[#0047ff] text-[9px] font-black tracking-wider uppercase border border-[#0047ff]/20"
        >
          {data.type}
        </a>
      </div>

      <div className="flex justify-between items-center mt-auto pt-2.5 border-t border-white/5">
        <div className="flex flex-wrap overflow-hidden -ml-1">
          {data.tags &&
            data.tags.slice(0, 5).map((tag, index) => (
              <a
                key={index}
                href={`/search?q=${tag.tag.toLowerCase()}&include=tag`}
                className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-neutral-900 border border-white/5 text-stone-300 text-[10px] font-semibold capitalize hover:border-white/20 transition-colors mr-2 my-1"
              >
                {tag.tag}
              </a>
            ))}
        </div>
        {data.type !== "Profil" && (
          <p className="text-[10px] text-stone-400 font-bold uppercase tracking-wider">
            Av: {data.author}
          </p>
        )}
      </div>
    </div>
  );
};

export default SearchResult;
